import { animated, useSpring } from 'react-spring';
import springConfig from 'lib/utils/springConfigs';
import { useScrollLock } from 'hooks';

const Sidebar = ({ isOpen, children, onClose, className = '' }) => {
  const sidebarSpring = useSpring({
    transform: isOpen ? 'translateX(0%)' : 'translateX(-100%)',
    config: springConfig.accordionWrapper,
  });

  useScrollLock(isOpen);

  return (
    <>
      <animated.div
        style={{ ...sidebarSpring }}
        className={`fixed top-0 left-0 z-[10000] h-full w-full max-w-[440px] overflow-y-hidden bg-white ${className}`}
      >
        {children}
      </animated.div>
      <button
        className={`fixed left-0 top-0 z-[9999] h-full w-full bg-blue bg-opacity-30 transition-opacity duration-300 ${
          isOpen ? 'opacity-100' : 'pointer-events-none opacity-0'
        }`}
        onClick={onClose}
        type="button"
        aria-label="Close"
      />
    </>
  );
};

export default Sidebar;
